import { useEffect, useState } from 'react';
import { fetchSiteSettings } from '../siteSettings';

const POLL_MS = 30_000;

export function useMaintenanceMode(isAdminDomain: boolean) {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [checked, setChecked] = useState(isAdminDomain);

  useEffect(() => {
    if (isAdminDomain) return;

    let cancelled = false;

    const check = async () => {
      const settings = await fetchSiteSettings();
      if (!cancelled) {
        setMaintenanceMode(settings.maintenance_mode);
        setChecked(true);
      }
    };

    check();
    const id = window.setInterval(check, POLL_MS);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [isAdminDomain]);

  return { maintenanceMode, checked };
}
